// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1FPqb","title":"Info_title__wVEZ9","selects":"Info_selects__2cVH1","requiredAsterisk":"Info_requiredAsterisk__2A-Vu"};